import { useAutoScaler } from '../../hooks/useAutoScaler';
import { DevLanding } from '../components/aida/DevLanding';
import { DevExplore } from '../components/aida/DevExplore';
import { FAQ } from '../components/aida/FAQ';
import { DevCTA } from '../components/aida/DevCTA';
import '../../styles/aida-base.css';
import '../../styles/aida-responsive.css';

const NEBULA_BACKGROUND = [
  'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.85) 10%, rgba(0,0,0,0.2) 25%, rgba(0,0,0,0.0) 40%, rgba(0,0,0,0.0) 60%, rgba(0,0,0,0.2) 75%, rgba(0,0,0,0.85) 90%, rgba(0,0,0,1) 100%)',
  'linear-gradient(90deg, rgba(120,40,255,0.55), rgba(180,60,255,0.55))',
  'radial-gradient(1400px at 50% 40%, rgba(255,255,255,0.03), rgba(60,0,90,0) 75%)',
  'radial-gradient(1000px at 15% 35%, rgba(140,40,255,0.40), rgba(40,0,70,0) 75%)',
  'radial-gradient(900px at 55% 60%, rgba(160,50,255,0.30), rgba(35,0,60,0) 80%)',
  'radial-gradient(1000px at 85% 70%, rgba(200,70,255,0.40), rgba(45,0,70,0) 80%)',
  'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.00) 60%)',
  'radial-gradient(circle at 50% 25%, #2a0050 0%, #1a0038 35%, #000000 75%, #000000 100%)',
].join(', ');

const NEBULA_BLEND_MODE = 'normal, soft-light, overlay, screen, screen, screen, soft-light, multiply';

const OBLIVION_BACKGROUND = [
  'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.85) 10%, rgba(0,0,0,0.2) 25%, rgba(0,0,0,0.0) 40%, rgba(0,0,0,0.0) 60%, rgba(0,0,0,0.2) 75%, rgba(0,0,0,0.85) 90%, rgba(0,0,0,1) 100%)',
  'radial-gradient(600px at 20% 25%, rgba(90, 70, 140, 0.25), rgba(20, 19, 53, 0) 70%)',
  'radial-gradient(700px at 75% 55%, rgba(60, 70, 120, 0.22), rgba(20, 19, 53, 0) 75%)',
  'radial-gradient(650px at 30% 85%, rgba(70, 65, 110, 0.20), rgba(20, 19, 53, 0) 75%)',
  'linear-gradient(90deg, #1c1b45, #141335, #1c1b45)',
].join(', ');

const OBLIVION_BLEND_MODE = 'normal, screen, screen, screen, multiply';

export const Developers = () => {
  const { isContentReady } = useAutoScaler();

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: 'black',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
      }}
    >
      <div style={{ paddingTop: '60px', display: 'flex', justifyContent: 'center', margin: 0, padding: 0 }}>
        <div
          id="auto-scaler"
          style={{
            width: '1024px',
            transformOrigin: 'top center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: 0,
            padding: 0,
            marginBottom: 0,
            overflow: 'visible',
            opacity: isContentReady ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out',
          }}
        >
          {/* Background Zone 0 — hero */}
          <div style={{ width: '100%' }}>
            <div style={{ width: '100%' }}>
              <DevLanding />
            </div>
          </div>

          {/* Background Zone 1 — oblivion (DevExplore) */}
          <div
            id="dev-explore"
            style={{
              width: '100%',
              background: OBLIVION_BACKGROUND,
              backgroundBlendMode: OBLIVION_BLEND_MODE,
            }}
          >
            <div style={{ width: '100%' }}>
              <DevExplore />
            </div>
          </div>

          {/* Background Zone 2 — FAQ */}
          <div style={{ width: '100%' }}>
            <div style={{ width: '100%', marginTop: '40px' }}>
              <FAQ />
            </div>
          </div>

          {/* Dev CTA */}
          <div style={{ width: '100%', marginTop: '40px' }}>
            <DevCTA />
          </div>
        </div>
      </div>
    </div>
  );
};
